import React from "react";
import styled from "styled-components";
import { GlobalColors } from "./constant/Global";
import NameCard from "./NameCard";

const CardWrapper = styled.div`
  color: ${GlobalColors.dark};
  background: linear-gradient(
    to right,
    ${(props) => props.primary_color || GlobalColors.primary} 0%,
    ${(props) => props.secondary_color || GlobalColors.secondary} 100%
  );
  min-height: 100%;
`;

const Spinner = styled.span`
  width: 48px;
  height: 48px;
  border: 5px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: App-logo-spin 1s linear infinite;
`

const CardTemplate = (data) => {
  const { profileData } = data;
  return Object.keys(profileData).length != 0 ?
    (
      <CardWrapper
        primary_color={
          profileData ? profileData.primaryColor : GlobalColors.primary
        }
        secondary_color={
          profileData ? profileData.secondaryColor : GlobalColors.secondary
        }
      >
        <NameCard profileData={profileData} />
      </CardWrapper>
    ) :
    (
      <div style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Spinner />
      </div>
      
    )

};

export default CardTemplate;
